import React, { useState } from "react";
import "./Navbar.scss"
import logo from "../../assets/images/logo.png"
import menu from "../../assets/icons/menu.svg"
import close from "../../assets/icons/close.svg"

import { useHistory } from "react-router";
import { useSelector } from "react-redux";
const Navbar = () => {
    const history = useHistory()
    const [showDropdown, setShowDropdown] = useState(false)
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "navbar")
    const Components = page?.Components ?? []
    const leftComponent = Components?.find((component) => component?.ID === "DosaChutneyNavbar-Navbar")?.Props ?? null
    const linksComponent = Components?.find((component) => component?.ID === "DosaChutneyNavbar-Navbar-link")?.Data ?? []
    const buttonComponent = Components?.find((component) => component?.ID === "DosaChutneyNavbar-Navbar-button")?.Props ?? null

    return (
        <div className="DosaChutneyNavbar">
            <div className="DosaChutneyNavbar-inner">
                {leftComponent && <img className="DosaChutneyNavbar-logo" alt=""
                    src={leftComponent?.src}
                    onClick={() => {
                        history.push(leftComponent?.href)
                    }} />}
                <div className="DosaChutneyNavbar-innerRight">
                    <div className="DosaChutneyNavbar-links">
                        {linksComponent.map((page, key) => {
                            return (
                                <div
                                    className={`Navbarlink-title  ${window.location.pathname === page?.href ? "selected" : ""}`}
                                    key={key}
                                    onClick={() => {
                                        if (page?.href?.includes("https://")) {
                                            if (page?.href && page?.href !== "") {
                                                window.open(page?.href, '_blank')
                                            }
                                        } else {
                                            history.push(page?.href)
                                        }
                                    }}>
                                    {page?.title}
                                </div>
                            )
                        })}
                    </div>
                    {buttonComponent && <div className="DosaChutneyNavbar-button"
                        onClick={() => {
                            if (buttonComponent?.href && buttonComponent?.href !== "") {
                                window.open(buttonComponent?.href, '_blank')
                            }
                        }
                        }>
                        {buttonComponent?.buttonText}
                    </div>}
                </div>
                {showDropdown ? <img className="DosaChutneyNavbar-icon" alt=""
                    onClick={() => {
                        setShowDropdown(!showDropdown)
                    }} src={close} /> :
                    <img className="DosaChutneyNavbar-icon" alt="" src={menu}
                        onClick={() => {
                            setShowDropdown(!showDropdown)
                        }} />}

            </div>
            {showDropdown && <div className={`DosaChutneyNavbar-Dropdown open`}>
                <div className="DosaChutneyNavbar-links">
                    {linksComponent.map((page, key) => {
                        return (
                            <div
                                className={`Navbarlink-title  ${window.location.pathname === page?.href ? "selected" : ""}`}
                                key={key}
                                onClick={() => {
                                    if (page?.href?.includes("https://")) {
                                        if (page?.href && page?.href !== "") {
                                            window.open(page?.href, '_blank')
                                        }
                                    } else {
                                        history.push(page?.href)
                                    }
                                    setShowDropdown(false)
                                }}>
                                {page?.title}
                            </div>
                        )
                    })}
                </div>
                {buttonComponent &&
                    <div className="DosaChutneyNavbar-button"
                        onClick={() => {
                            if (buttonComponent?.href && buttonComponent?.href !== "") {
                                window.open(buttonComponent?.href, '_blank')
                            }
                        }
                        }>
                        {buttonComponent?.buttonText}
                    </div>
                }
            </div>}

        </div>
    )
}
export default Navbar